import { render, staticRenderFns } from "./GisogdDocProperties.vue?vue&type=template&id=3e2d1431&scoped=true&"
import script from "./GisogdDocProperties.vue?vue&type=script&lang=js&"
export * from "./GisogdDocProperties.vue?vue&type=script&lang=js&"
import style0 from "./GisogdDocProperties.vue?vue&type=style&index=0&id=3e2d1431&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2d1431",
  null
  
)

export default component.exports